import type React from "react";
import { Box, Typography } from "@mui/material";

interface DetailFieldProps {
  label: string;
  value: React.ReactNode;
  /** Bold value text — used on report order cards to match order detail. */
  emphasized?: boolean;
}

const DetailField: React.FC<DetailFieldProps> = ({ label, value, emphasized = false }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.25 }}>
      {label}
    </Typography>
    <Typography variant="body2" component="div" sx={emphasized ? { fontWeight: 600 } : undefined}>
      {value}
    </Typography>
  </Box>
);

export default DetailField;
